import React, { useState } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Icon from '../../icon/Icon';
import { ColorTokens, IconSizeTokens, IconTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Typography from '../../typography/Typography';
import ShimmerTable from '../customerDetailsTable/ShimmerTable';
const CustomerListType = ({ title, iconName, count, bgColor, action, handleNavigation, setData, triggerAction, }) => {
    const [showShimmer, setShowShimmer] = useState(false);
    const handleActionPress = async () => {
        setData([]);
        setShowShimmer(true);
        await triggerAction({
            ...action,
            payload: {
                tabClicked: true,
            }
        });
        setShowShimmer(false);
        handleNavigation();
    };
    const renderContent = () => {
        return (React.createElement(TouchableOpacity, { onPress: handleActionPress, style: { marginTop: 16, borderColor: '#E4E7EC', borderWidth: 1, borderRadius: 8, backgroundColor: '#FFFFFF' } },
            React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 16, paddingVertical: 28 } },
                React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center' } },
                    React.createElement(View, { style: { padding: 8, backgroundColor: '#F3F5FC', borderRadius: 120 } },
                        React.createElement(Icon, { name: iconName, color: ColorTokens.Primary_100, size: IconSizeTokens.XXL })),
                    React.createElement(View, { style: { marginLeft: 8 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0M, label: title, color: ColorTokens.Grey_Night }))),
                React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center' } },
                    React.createElement(View, { style: { marginLeft: 8, backgroundColor: bgColor, paddingHorizontal: 5, paddingVertical: 1, borderRadius: 120 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: count, color: ColorTokens.White })),
                    React.createElement(Icon, { name: IconTokens.SYSTEM_CHEVRON_RIGHT_DLS, color: ColorTokens.Primary_100, size: IconSizeTokens.LG })))));
    };
    return showShimmer ? ShimmerTable() : renderContent();
};
const styles = StyleSheet.create({});
export default CustomerListType;
